import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { LINKS } from "@/lib/site";

// Slim sticky "book a call" bar for mobile - slides in once the hero is scrolled past.
export const MobileCta = () => {
  const [show, setShow] = useState(false);
  const [atContact, setAtContact] = useState(false);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("top");
    if (!hero) return;
    const io = new IntersectionObserver(([entry]) => setShow(!entry.isIntersecting), { threshold: 0 });
    io.observe(hero);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const contact = document.getElementById("contact");
    const footer = document.querySelector('[data-testid="site-footer"]');
    const visibleSections = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visibleSections.add(entry.target);
        else visibleSections.delete(entry.target);
      });
      setAtContact(visibleSections.size > 0);
    });
    [contact, footer].filter(Boolean).forEach((element) => io.observe(element));
    const onFocus = () => setEditing(Boolean(document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')));
    document.addEventListener("focusin", onFocus);
    document.addEventListener("focusout", onFocus);
    return () => {
      io.disconnect();
      document.removeEventListener("focusin", onFocus);
      document.removeEventListener("focusout", onFocus);
    };
  }, []);

  const visible = show && !atContact && !editing;

  return (
    <div
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-[130%]"
      }`}
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      aria-hidden={!visible}
      inert={!visible}
      data-testid="mobile-cta-bar"
    >
      <a
        href={LINKS.cal}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 bg-cobalt text-white border border-ink py-4 font-mono text-base font-medium uppercase tracking-[0.12em] shadow-[0_-6px_24px_rgba(10,12,34,0.28)] active:scale-[0.98] transition-transform"
        data-testid="mobile-cta-book"
      >
        Book a meeting
        <ArrowUpRight size={18} />
      </a>
    </div>
  );
};
